<div class="m-lg-5 m-md-3 m-1 mt-5 mb-5">
  <h1>Herzlich Willkommen in der Praxis</h1>
  <h2 class="md-2 text-muted"> Dr. med. Gunnar G. Pobel</h2>
</div>

<div class="p-lg-5 p-md-3 p-0 d-flex flex-wrap">
  <!--<app-d-arzt-tile class="p-2"></app-d-arzt-tile>-->
</div>
